<template>
    <div class="FBtn" @click="getClick" :class="{FBtn_Disabled:disabled}">
        <div :class="'FBtn_type_'+type">
            <svg viewBox="0 0 1024 1024" version="1.1" v-html="svgList[title]" v-if="svgList[title]"
                 :style="{width:IconSize+'px',height:IconSize+'px'}"></svg>
            <span>
                <slot>{{title||'按钮'}}</slot>
            </span>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/7 2:40 下午
     */
    import config from '@/assets/js/config'

    export default {
        name: 'FBtn',
        components: {},
        props: {
            title: {
                type: String,
                default: '按钮'
            },
            type: {
                type: Number / String,
                default: 1
            },
            IconSize: {
                type: Number / String,
                default: 24
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                svgList: {
                    '新建组': '<path d="M616.354915 264.365786V0H143.279299A83.483932 83.483932 0 0 0 59.795367 83.483932v857.032136a83.483932 83.483932 0 0 0 83.483932 83.483932h737.441402a83.483932 83.483932 0 0 0 83.483932-83.483932V347.849718H699.838848a83.483932 83.483932 0 0 1-83.483933-83.483932z m111.31191 313.760445a41.741966 41.741966 0 0 1-41.741966 41.741967H553.741966v132.182892a41.741966 41.741966 0 0 1-83.483932 0v-132.182892H338.075141a41.741966 41.741966 0 0 1 0-83.483933h132.182893v-132.182893a41.741966 41.741966 0 1 1 83.483932 0v132.182893h132.182893a41.741966 41.741966 0 0 1 41.741966 41.741966z" p-id="3792"></path><path d="M699.838848 0v264.365786h264.365785L699.838848 0z" p-id="3793"></path>',
                    '移动到': '<path d="M511.81795555 75.08195555L329.95555555 256.94435555l63.60177778 63.60177778 78.91626667-78.91626666v234.48462222H238.94471111L320.25031111 394.80888889l-63.80657778-63.7952-181.64622222 181.64622222 181.8624 181.8624 63.60177778-63.5904-75.28675556-75.28675556h227.49866667V779.83288889l-78.24497778-78.24497778-63.80657777 63.7952 181.6576 181.6576 181.8624-181.8624-63.60177778-63.60177778-78.336 78.336V555.64515555h225.91715555l-74.27413333 74.27413334 63.80657778 63.80657778 181.64622222-181.6576-181.8624-181.8624-63.60177778 63.60177778 82.31822222 82.30684444H552.00426667v-233.24444444l77.67608888 77.6647111 63.7952-63.7952z" p-id="3949"></path>',
                    '图层': '<path d="M917.3 649.6c-5.7 0-11.1 1.2-16.1 3.2l-0.2 0.1-0.2 0.1-389.6 161.2L121.5 653c-0.1 0-0.1-0.1-0.2-0.1l-0.2-0.1c-21.2-8-45 2.3-53.7 23.2-8.7 21 0.9 45 21.6 54.4l405.8 167.9c0.1 0 0.1 0.1 0.2 0.1l0.2 0.1c10.3 4.3 21.8 4.3 32.1 0l0.2-0.1c0.1 0 0.1-0.1 0.2-0.1l405.8-167.9c18.5-7.7 29.1-27.3 25.1-47-4-19.6-21.3-33.8-41.3-33.8zM89 366.3l405.8 167.9 0.2 0.1 0.2 0.1c10.3 4.3 21.8 4.3 32.1 0l0.2-0.1c0.1 0 0.1-0.1 0.2-0.1l405.8-167.9c15.7-6.5 25.9-21.8 26-38.8 0-17-10.2-32.3-26-38.8L527.6 120.8c-0.1 0-0.1-0.1-0.2-0.1l-0.2-0.1a41.55 41.55 0 0 0-32.1 0l-0.2 0.1c-0.1 0-0.1 0.1-0.2 0.1L88.9 288.7c-15.7 6.5-25.9 21.8-26 38.8 0.1 17 10.4 32.3 26.1 38.8z m828.3 101.2c-5.7 0-11.1 1.2-16.1 3.2l-0.2 0.1c-0.1 0-0.1 0.1-0.2 0.1L511.2 632.1 121.5 470.9c-0.1 0-0.1-0.1-0.2-0.1l-0.2-0.1c-21.3-8.2-45.2 2.1-53.9 23.2-8.7 21 0.9 45.2 21.8 54.5l405.8 167.9 0.2 0.1 0.2 0.1c10.3 4.3 21.8 4.3 32.1 0l0.2-0.1c0.1 0 0.1-0.1 0.2-0.1l405.8-167.9c18.5-7.7 29.1-27.3 25.1-47s-21.3-33.9-41.3-33.9z m0 0" p-id="2123"></path>'

                }
            }
        },
        methods: {
            //点击事件
            getClick() {
                if (!this.disabled) {
                    this.$emit("click");
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .FBtn {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        .noSelect;

        > div {
            .com_btn;
            transition: .1s;

            > svg {
                vertical-align: middle;
                margin-right: 8px;
                margin-top: -5px;
                width: 24px;
                height: 24px;
                fill: #999;
            }

            > span {
                color: #999;
            }
        }

        .FBtn_type_0 {
            background-color: #fff;
            border: 1px solid @h_main_backColor;

            > svg {
                fill: #999;
            }

            > span {
                color: #999;
            }
        }

        .FBtn_type_0:hover {
            border: 1px solid rgba(19, 181, 177, 1);

            > svg {
                fill: @green;
            }

            > span {
                color: @green;
            }
        }

        .FBtn_type_1:hover {
            // background-color: rgba(19, 181, 177, 0.2);
            background-color: #39ae78;
        }

        .FBtn_type_2:hover {
            background-color: rgba(19, 181, 177, 0.75);
        }

        .FBtn_type_3:hover {
            background-color: rgba(236, 105, 65, 0.75)
        }

        .FBtn_type_1 {
            background-color: rgba(0, 0, 0, 0);
            background-color: #39ae78;
            border: 1px solid transparent;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;

            }
        }

        .FBtn_type_2 {
            background-color: @green;
            border: 1px solid @green;

            > svg {
                fill: #fff;
            }

            > span {
                color: #fff;
            }
        }

        .FBtn_type_3 {
            background-color: @orange;
            border: 1px solid @orange;

            > svg {
                fill: #fff;
            }

            > span {
                color: #fff;
            }
        }
        .FBtn_type_4 {
            background-color: transparent;
            border: 1px solid red;

            > svg {
                fill: @green;
            }

            > span {
                color: red;
            }
        }
        .FBtn_type_5 {
            background-color: transparent;
            border: 1px solid #00a1fe;

            > svg {
                fill: @green;
            }

            > span {
                color: #00a1fe;
            }
        }
        .FBtn_type_6 {
            background-color: #00a1fe;
            border: 1px solid transparent;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;
            }
        }
        .FBtn_type_7 {
            // background-color: #002774;
            border: 1px solid transparent;
            // padding: 0 60px;
            > svg {
                fill: @green;
            }

            > span {
                color: #002774;
                font-size: 16px;
                position: relative;
            }
            span::before {
                content: '';
                width: 6px;
                height: 6px;
                border-radius: 50%;
                position: absolute;
                background: #002774;
                left: -10px;
                bottom: 11px;
            }
            
        }
        .FBtn_type_8 {
            border: 1px solid transparent;
            // padding: 0 60px;
            > svg {
                fill: @green;
            }

            > span {
                color: #f76969;
                font-size: 16px;
                position: relative;

            }
            span::before {
                content: '';
                width: 6px;
                height: 6px;
                border-radius: 50%;
                position: absolute;
                background: #f76969;
                left: -10px;
                bottom: 11px;
            }
            
        }
        .FBtn_type_9 {
            border: 1px solid transparent;
            // padding: 0 60px;
            > svg {
                fill: @green;
            }

            > span {
                color: #39ae78;
                font-size: 16px;
                position: relative;

            }
            span::before {
                content: '';
                width: 6px;
                height: 6px;
                border-radius: 50%;
                position: absolute;
                background: #39ae78;
                left: -10px;
                bottom: 11px;
            }
            
        }
        .FBtn_type_10 {
            background-color: #002774;
            border: 1px solid transparent;
            padding: 0 50px;
            margin-left: 20px;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;
            }
            
        }
        .FBtn_type_11 {
            background-color: #999999;
            border: 1px solid transparent;
            padding: 0 50px;
            margin-left: 20px;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;
            }
            
        }
        .FBtn_type_12 {
            background-color: #39ae78;
            border: 1px solid transparent;
            padding: 0px 36px;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;
            }
            
        }
        .FBtn_type_13 {
            background-color: #999;
            border: 1px solid transparent;
            padding: 0px 36px;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;
            }
            
        }
        .FBtn_type_14 {
            background-color: #2468ee;
            border: 1px solid transparent;
            padding: 0px 34px;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;
            }
            
        }
        .FBtn_type_15 {
            border: 1px solid transparent;
            // padding: 0 60px;
            > svg {
                fill: @green;
            }

            > span {
                color: #ff8034;
                font-size: 16px;
                position: relative;

            }
            span::before {
                content: '';
                width: 6px;
                height: 6px;
                border-radius: 50%;
                position: absolute;
                background: #ff8034;
                left: -10px;
                bottom: 11px;
            }
            
        }
        .FBtn_type_16 {
            height: 42px;
            background-color: #2468ee;
            border: 1px solid transparent;
            padding: 0 !important;
            font-size: 20px;
            border-radius: 10px;
            margin-left: 30px;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;
                height: 42px;
                line-height: 42px;
                margin: 0 36px;
            }
        }
        .FBtn_type_17 {
            height: 42px;
            background-color: #999999;
            border: 1px solid transparent;
            padding: 0 !important;
            font-size: 20px;
            border-radius: 10px;
            margin-left: 30px;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;
                height: 42px;
                line-height: 42px;
                margin: 0 36px;
            }
        }
        .FBtn_type_18 {
            height: 42px;
            background-color: #39ae78;
            border: 1px solid transparent;
            padding: 0 !important;
            font-size: 20px;
            border-radius: 10px;
            margin-left: 30px;

            > svg {
                fill: @green;
            }

            > span {
                color: #fff;
                height: 42px;
                line-height: 42px;
                margin: 0 36px;
            }
        }
        .FBtn_type_19 {
            background-color: #002774;
            border: 1px solid #002774;

            > svg {
                fill: #fff;
            }

            > span {
                color: #fff;
            }
        }

        > div:active {
            opacity: 0.6;
        }
    }

    .FBtn + .FBtn {
        margin-left: 10px;
    }

    .FBtn_Disabled {
        > div {
            background-color: #f5f5f5 !important;
            border-color: #d5d5d5 !important;
            cursor: not-allowed !important;

            > svg {
                fill: #666 !important;
            }

            > span {
                color: #666 !important;
            }
        }
    }
</style>
